export type NumeroProva = { valor: number; rotulo: string };

/**
 * A ÚNICA fonte do "cláusulas versionadas na biblioteca".
 *
 * A página chegou a publicar 23 aqui e 18 em `documentos.tsx` — dois números
 * diferentes para a mesma afirmação, e nenhum dos dois verdadeiro (18 era o
 * nº de capítulos; 23, o de regras de conferência do cadastro). O valor real
 * é o de chaves distintas em `packages/clausulas/src/biblioteca/`, e
 * `numeros.test.ts` compara os dois: se a biblioteca crescer, o teste avisa
 * antes de a landing mentir para menos.
 */
export const CLAUSULAS_NA_BIBLIOTECA = 84;

/**
 * O total de conferências: 33 regras de cadastro (`REGRAS_SOCIEDADE`) + 7 de
 * coerência do documento (`REGRAS_COERENCIA`). O valor publicado chegou a
 * ficar em 30 enquanto o validador crescia para 40 — `conferencias.test.ts`
 * agora compara id a id com `@social/validador`, e o marquee da tira de
 * prova nomeia cada uma (`conferencias.ts`).
 */
export const CONFERENCIAS_NO_SISTEMA = 40;

/**
 * Só números verdadeiros, contados no código — nenhuma estatística de uso,
 * cliente ou tempo economizado (não existe fonte para isso ainda).
 */
export const NUMEROS_PROVA: readonly NumeroProva[] = [
  { valor: CONFERENCIAS_NO_SISTEMA, rotulo: 'conferências no cadastro e no documento' },
  { valor: CLAUSULAS_NA_BIBLIOTECA, rotulo: 'cláusulas versionadas na biblioteca' },
  { valor: 7, rotulo: 'tipos societários atendidos' },
  { valor: 2, rotulo: 'formatos de saída: .docx e PDF' },
  { valor: 7, rotulo: 'dias de teste grátis, sem cartão' },
] as const;
